// extracted by mini-css-extract-plugin
export var eyebrow = "twoColumnHeader-module--eyebrow--cd179";
export var gridText = "twoColumnHeader-module--gridText--1c018";
export var headline = "twoColumnHeader-module--headline--12dfa";
export var left = "twoColumnHeader-module--left--0c581";
export var right = "twoColumnHeader-module--right--2fc17";
export var subtext = "twoColumnHeader-module--subtext--6388f";